// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function StudentIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m28.316 7.051-12-4a1 1 0 0 0-.632 0l-12 4A1 1 0 0 0 3 8v10a1 1 0 1 0 2 0V9.387l4.199 1.4a8 8 0 0 0 2.581 11.005c-2.25.883-4.195 2.48-5.617 4.662a1 1 0 1 0 1.675 1.092C9.72 24.656 12.695 23 16 23c3.304 0 6.279 1.656 8.163 4.546a1 1 0 0 0 1.674-1.092c-1.422-2.183-3.375-3.779-5.617-4.662a8 8 0 0 0 2.581-11l5.515-1.837a1 1 0 0 0 0-1.897V7.05ZM22 15a6 6 0 1 1-10.831-3.556l4.515 1.5a.999.999 0 0 0 .632 0l4.515-1.5A5.986 5.986 0 0 1 22 15Zm-6-4.054L7.162 8 16 5.054 24.837 8 16 10.946Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
